/* global axios */
import ApiClient from './ApiClient';
import { buildSummaryReportParams } from './buildSummaryReportParams';

class SummaryReportsAPI extends ApiClient {
  constructor() {
    super('summary_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getTeamReports(params = {}) {
    return axios.get(`${this.url}/team`, {
      params: buildSummaryReportParams(params),
    });
  }

  getAgentReports(params = {}) {
    return axios.get(`${this.url}/agent`, {
      params: buildSummaryReportParams(params),
    });
  }

  getInboxReports(params = {}) {
    return axios.get(`${this.url}/inbox`, {
      params: buildSummaryReportParams(params),
    });
  }

  getLabelReports(params = {}) {
    return axios.get(`${this.url}/label`, {
      params: buildSummaryReportParams(params),
    });
  }

  getOverviewReports(params = {}) {
    return axios.get(`${this.url}/overview`, {
      params: buildSummaryReportParams(params),
    });
  }

  getChatsReports(params = {}) {
    return axios.get(`${this.url}/chats`, {
      params: buildSummaryReportParams(params),
    });
  }

  getChatsTimeSummary(params = {}) {
    return axios.get(`${this.url}/chats_time_summary`, {
      params: buildSummaryReportParams(params),
    });
  }
}

export default new SummaryReportsAPI();
